import { render, staticRenderFns } from "./AppCardCode.vue?vue&type=template&id=566be365&scoped=true&"
import script from "./AppCardCode.vue?vue&type=script&lang=js&"
export * from "./AppCardCode.vue?vue&type=script&lang=js&"
import style0 from "./AppCardCode.vue?vue&type=style&index=0&id=566be365&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566be365",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
